import z from 'zod/v3';
import translations from './zGroupDescriptionRef.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { GroupDescriptionRef } from '../../../dataobject';

const { addTranslations, t } = i18nNsFactory('z-group-description-ref');
addTranslations(translations);

export const zGroupDescriptionRef = z
  .custom<GroupDescriptionRef>((value) => typeof value === 'string')
  .superRefine((value, ctx) => {
    if (!/^\d+(-\d+)?$/.test(value)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t('invalid-format'),
      });
    }
  });
